/* eslint-disable camelcase */
import homeConfig from './home.config';
import searchWorksConfig from './search-works.config';
import searchBooksConfig from './search-books.config';
import searchWitnessesConfig from './search-witnesses.config';
import searchBibliografia from './search-bibliography.config';
import searchIconographiesConfig from './search-iconographies.config';
import searchToolsConfig from './search-tools.config';
import searchBiographiesConfig from './search-biographies.config';
import resourceBookConfig from './resource-book.config';
import resourceToponymConfig from './resource-toponym.config';
import resourceIconographyConfig from './resource-iconography.config';
import resourceKeywordConfig from './resource-keyword.config';
import resourceWorkConfig from './resource-work.config';
import resourceTextConfig from './resource-text.config';
import resourceBiographyConfig from './resource-biography.config';
import resourceModalBibliography_witConfig from './resource-modal-bibliography_wit.config';
import resourceToolConfig from './resource-tool.config';
import itineraryConfig from './itinerary.config';
import advancedSearchConfig from './advanced-search.config';
import advancedResultsConfig from './advanced-results.config';
// Project resource - TAB
import tabsConfig from './tabs.config';
import resourceProjectConfig from './project/resource-project.config';
import resourceProjectIntroductionConfig from './project/resource-project-introduction.config';
import resourceProjectWitnessesConfig from './project/resource-project-witnesses.config';
import resourceProjectDigitalResourceConfig from './project/resource-project-digital-resource.config';
import resourceProjectNotesConfig from './project/resource-project-notes.config';
import resourceProjectStemmaConfig from './project/resource-project-stemma.config';
import resourceProjectGlossaryConfig from './project/resource-project-glossary.config';
import resourceProjectBibliographyConfig from './project/resource-project-bibliography.config';
import searchProjectsConfig from './search-projects.config';
// Witness resource
import resourceManuscriptConfig from './resource-manuscript.config';

export default {
  tabs: tabsConfig,
  home: homeConfig,
  itinerary: itineraryConfig,
  'search-works': searchWorksConfig,
  'search-books': searchBooksConfig,
  'search-witnesses': searchWitnessesConfig,
  'resource-biography': resourceBiographyConfig,
  'resource-tool': resourceToolConfig,
  'search-tools': searchToolsConfig,
  'search-biographies': searchBiographiesConfig,
  'resource-iconography': resourceIconographyConfig,
  'search-iconographies': searchIconographiesConfig,
  'resource-work': resourceWorkConfig,
  'resource-text': resourceTextConfig,
  'resource-book': resourceBookConfig,
  'resource-toponym': resourceToponymConfig,
  'resource-keyword': resourceKeywordConfig,
  'search-bibliografia': searchBibliografia,
  'resource-modal-bibliography_wit': resourceModalBibliography_witConfig,
  'advanced-search': advancedSearchConfig,
  'advanced-results': advancedResultsConfig,
  // Project
  'resource-project': resourceProjectConfig,
  'resource-project-introduction': resourceProjectIntroductionConfig,
  'resource-project-witnesses': resourceProjectWitnessesConfig,
  'resource-project-digital-resource': resourceProjectDigitalResourceConfig,
  'resource-project-notes': resourceProjectNotesConfig,
  'resource-project-stemma': resourceProjectStemmaConfig,
  'resource-project-glossary': resourceProjectGlossaryConfig,
  'resource-project-bibliography': resourceProjectBibliographyConfig,
  'search-projects': searchProjectsConfig,
  // Manuscript
  'resource-manuscript': resourceManuscriptConfig,
};
